
<template>
  <div id="AnalyticMachine">
    <Header :title="$t('Header.SuperAmin')" logoutPath="/SuperAdmin/Login" />
    <Menu />

    <div class="pnlBEContent scrollBar">
      <TitleBar :iconSrc="require('@/assets/img/menu/icon_VR_S_hover.png')" :title="$t('SAAnalyticMachine.PageName')">
      </TitleBar>

      <div class="pnlBESearchScroll">
        <div class="searchTools">
          <label class="lblSearchTitle">開始時間</label>
          <Datepicker
            format="yyyy-MM-dd"
            v-model="search.startDate"
            class="lblSearchDate"
            :placeholder="$t('SESGRecord.PlaceholderStartDate')"
            :disabled-dates="disableStartDates"
            @closed="OnStartDateSelectChange"
          ></Datepicker>
          <label class="lblSearchTitle">結束時間</label>
          <Datepicker
            format="yyyy-MM-dd"
            v-model="search.endDate"
            class="lblSearchDate"
            :placeholder="$t('SESGRecord.PlaceholderEndDate')"
            :disabled-dates="disableEndDates"
          ></Datepicker>
          <label class="lblSearchTitle">學校</label>
          <input type="text" class="searchKeyin" v-model="search.school" />

          <button class="btnWidthIcon iconSearch" @click="SearchInfo">
            {{ $t('SESGRecord.BtnSearch') }}
          </button>
          <button class="btnWidthIcon iconDownload" @click="downloadFile" v-if="analyticData.length != 0">
            {{ $t('SESGRecord.RecordDownload') }}
          </button>
        </div>
        <div style="clear: both"></div>
        <table id="tableMachine" class="AnalyticLectureTable">
          <tr>
            <th>縣市</th>
            <th>學校</th>
            <th>裝置序號</th>
            <th>裝置名稱</th>
            <th>時數</th>
            <th>次數</th>
          </tr>
          <template v-for="school in analyticData">
            <tr v-for="(machine, machineIndex) in school.machineRecordInfo" :key="machine.machineID">
              <td :rowspan="CalcSchoolRowspan(school.machineRecordInfo)" v-if="CalcSchoolShow(machineIndex)">
                {{ school.county }}
              </td>
              <td :rowspan="CalcSchoolRowspan(school.machineRecordInfo)" v-if="CalcSchoolShow(machineIndex)">
                {{ school.school }}
              </td>
              <td>{{ machine.machineID }}</td>
              <td>{{ machine.des }}</td>
              <td>{{ machine.useTime }}</td>
              <td>{{ machine.useNumber }}</td>
            </tr>
          </template>
          <tr v-if="analyticData.length == 0">
            <td colspan="6">此篩選條件查無資料，請更改篩選條件。</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/SuperAdmin/Menu.vue';
import TitleBar from '@/components/TitleBar.vue';
import Datepicker from 'vuejs-datepicker';
import { apiGetAnalyticMachine } from '@/request.js';

export default {
  data() {
    return {
      search: {
        startDate: new Date(),
        endDate: new Date(),
        school: '',
      },
      analyticData: [],
    };
  },
  computed: {
    disableStartDates: function () {
      return { from: new Date() };
    },
    disableEndDates: function () {
      let dtStart = new Date(this.search.startDate);
      dtStart.setDate(dtStart.getDate() + parseInt(1));
      return { to: dtStart, from: this.tomorrow };
    },
    tomorrow: function () {
      let tomorrowDate = new Date();
      tomorrowDate.setDate(tomorrowDate.getDate() + parseInt(1));
      return tomorrowDate;
    },
  },
  mounted() {
    this.search.endDate = this.tomorrow;
    this.SearchInfo();
  },
  methods: {
    CalcSchoolRowspan(machineInfo) {
      return machineInfo.length;
    },
    CalcSchoolShow(machineIndex) {
      return machineIndex == 0 ? true : false;
    },
    OnStartDateSelectChange() {
      let dtStart = new Date(this.search.startDate);
      let dtEnd = new Date(this.search.endDate);
      if (dtStart >= dtEnd) {
        dtStart.setDate(dtStart.getDate() + parseInt(1));
        this.search.endDate = dtStart;
      }
    },
    SearchInfo() {
      let startDate = this.GetDateFormat(this.search.startDate);
      let endDate = this.GetDateFormat(this.search.endDate);
      //console.log(`startDate: ${startDate} ,endDate: ${endDate} ,school: ${this.search.school}`);

      
      let data = {
        startdate: startDate,
        enddate:endDate,
        school:this.search.school
      };
      apiGetAnalyticMachine(data).then((res) => {
        //console.log(JSON.stringify(res.data.analyticData));
        if(res.data.analyticData != null)
        {
          this.analyticData = res.data.analyticData;
        }
        else{
          this.analyticData = [];
        }        
      });

      // this.analyticData = [
      //   {
      //     county: '市',
      //     school: 'XX學校',
      //     machineRecordInfo: [
      //       {
      //         machineID: 'aatest',
      //         des: 'm 01',
      //         useTime: '0s',
      //         useNumber: 0,
      //       },
      //     ],
      //   },
      //   {
      //     county: '台北市',
      //     school: '闇橡國小',
      //     machineRecordInfo: [
      //       {
      //         machineID: 'UnityEditor1',
      //         des: 'Test2',
      //         useTime: '5m0s',
      //         useNumber: 1,
      //       },
      //       {
      //         machineID: 'tmp',
      //         des: 'Test1',
      //         useTime: '0s',
      //         useNumber: 0,
      //       },
      //     ],
      //   },
      // ];
    },
    GetDateFormat(date) {
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    downloadFile() {
      //globalFunction.js
      this.ExportExcel('tableMachine');
    },
  },
  components: {
    Header,
    Menu,
    TitleBar,
    Datepicker,
  },
};
</script>
